export const strings = {
  NAME: "Link cards",
  DESCRIPTION: "Create a directory or share links to helpful resources.",
} as const;
